import type { GameConfig } from '../../config/gameConfig';

function clampAge(config: GameConfig, age: number): number {
    return Math.max(0, Math.min(age, config.tree.maxAge));
}

export function getTreeYieldMultiplier(config: GameConfig, age: number): number {
    const clamped = clampAge(config, age);
    const { peakAge, maxAge, yieldMinMultiplier, yieldTailMultiplier } = config.tree;
    if (maxAge <= 0) return 1;
    if (clamped <= peakAge || maxAge === peakAge) {
        const denom = peakAge === 0 ? 1 : peakAge;
        return yieldMinMultiplier + (1 - yieldMinMultiplier) * (clamped / denom);
    }
    const denom = Math.max(1, maxAge - peakAge);
    return 1 - (1 - yieldTailMultiplier) * ((clamped - peakAge) / denom);
}

export function getTreeYield(config: GameConfig, age: number): number {
    const clamped = clampAge(config, age);
    const { yieldBase, yieldAgeFactor } = config.tree;
    return (
        yieldBase + Math.round(clamped * yieldAgeFactor * getTreeYieldMultiplier(config, clamped))
    );
}

export function getTreeCutWork(config: GameConfig, age: number): number {
    const clamped = clampAge(config, age);
    return config.tree.cutWorkBase + config.tree.cutWorkPerAge * clamped;
}
